import { Language } from '@yleisradio/areena-types';
import { ApplicationResolution } from '../applicationResolution';
import { cookieValue } from '../utils/cookie';
import {
  getLocalStorageValue,
  setLocalStorageValue,
} from '../utils/localStorage';
import { HOME_PATH } from '../Routes/routeNames';
import { LAUNCHER_REDIRECT } from '../constants';

type Props = {
  language: Language;
  applicationResolution: ApplicationResolution;
  e2eTests: boolean;
  withCurrentPath?: boolean;
  launcherUri?: string | null;
};

export const changeLanguageTo = ({
  language,
  applicationResolution,
  e2eTests,
  withCurrentPath = false,
  launcherUri = null,
}: Props) => {
  const pathname = withCurrentPath ? window.location.pathname : `/${HOME_PATH}`;
  setUILanguage(language);

  window.location.replace(
    `${window.location.origin}${pathname}?resolution=${applicationResolution}${e2eTests ? '&e2e_tests=true' : ''}${launcherUri?.length ? `&${LAUNCHER_REDIRECT}=${launcherUri}` : ''}`
  );
};

export function getUILanguage(): Language {
  const maybeLanguage = getLocalStorageValue<Language>(UI_LANGUAGE_KEY);

  if (maybeLanguage) return maybeLanguage;

  const language = getLegacyLanguageFromCookies() ?? fallbackLanguage;

  setUILanguage(language);

  return language;
}

export function setUILanguage(language: Language) {
  setLocalStorageValue(UI_LANGUAGE_KEY, language);
}

// TODO: Delete me after some time has passed. Legacy language-preference cookie
//  had expiration date after 52 weeks.
function getLegacyLanguageFromCookies() {
  return cookieValue(preferredLangCookieNameLegacy) as Language;
}

const UI_LANGUAGE_KEY = 'leanback-areena_ui-language';
const fallbackLanguage: Language = 'fi';
const preferredLangCookieNameLegacy = 'yle_hbbtv_language_preference';
